import { render, staticRenderFns } from "./PaymentFailure.vue?vue&type=template&id=174b8d1b&"
import script from "./PaymentFailure.vue?vue&type=script&lang=js&"
export * from "./PaymentFailure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports